import React, {useRef, useEffect} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, TagsOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tag} from 'antd';
import {getAll, drop} from '../../../../apis/MotivosApi';

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <TagsOutlined />
        <span>Motivos</span>
      </>
    ),
}];

const MotivosPage = () => {
    const [items, setItems] = React.useState([]);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [itemSelected, setItemSelected] = React.useState(null);

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 80,
      },
      {
        title: 'Clave',
        dataIndex: 'clave',
        key: 'clave',
      },
      {
        title: 'Descripción',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Activo',
        dataIndex: 'activo',
        key: 'activo',
        width: 100,
        render: (activo) => (
          <Tag color={activo ? 'green' : 'red'}>
            {activo ? 'Activo' : 'Inactivo'}
          </Tag>
        )
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        width: 200,
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setItemSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el registro?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('El registro ha sido eliminado!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setItemSelected(null);
    }

    const onHandlerFinish = async (refresh,  avoidClose) => {
      if(!avoidClose){
        setOpenEdit(false);
      }

      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }
    }

    const effectRan = useRef(false);
    useEffect(() => {
      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    
    return <PageApp routes={routes}>
      <Button type="primary" onClick={btnClick}>
          Agregar Motivo
      </Button>
      <Divider/>
      {
          items.length == 0 ? <Empty />:
          <Table dataSource={items} columns={columns} rowKey="id" />
      }
      {
        (openEdit && itemSelected && itemSelected.id > 0) &&
        <ModalEdit title={"Editar Motivo"} id={itemSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !itemSelected) &&
        <ModalEdit title={"Crear Motivo"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default MotivosPage;